import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { Helmet } from "react-helmet-async";
import TextInput from "../TextInput/TextInput"; 
import LogoWrapper from "../LogoWrapper/LogoWrapper";
import { useFont } from "../../contexts/FontContext/FontContext";
import { validateUsernameOrPassword } from "../utils/common";
import styles from "./ResetPassword.module.css";

const ResetPassword = () => {
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [error, setError] = useState("");
    const navigate = useNavigate();
    const { uid, token } = useParams();
    const fontSchemes = useFont();    
    const fontFamilyOne = fontSchemes.scheme_one; 

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (password !== confirmPassword) {
            setError("Passwords do not match.");
            return;
        }
        if (!validateUsernameOrPassword(password)) {
            setError("Password must be a minimum of 8 characters long and contain at least one number and one letter.");
            return;
        }
        try {
            const apiUrl = process.env.REACT_APP_API_URL;
            const response = await axios.post(`${apiUrl}/api/reset_password/${uid}/${token}/`, {
                password: password,
            });

            if (response.status === 200) { navigate("/login?message=Password reset successful. You may now log in."); }
        } catch (error) {
            setError("An error occurred while resetting the password. Please try again.");
            console.log(error)
        }
    };

    return (
        <div className={`${styles.reset_password_container} ${fontFamilyOne}`}>
            <Helmet>
                <title>Reset Password</title>
            </Helmet>
            <LogoWrapper class_={styles.reset_password_logo} src={`${process.env.PUBLIC_URL}/images/partial_logo.png`} />
            <p className={`titles`}>Reset Your Password</p>
            {error && 
                <div className={`validation_wrapper ${styles.reset_validation_wrapper}`}>
                    <p className="error_message">{error}</p>
                </div>
            }
            <form className={styles.reset_password_form} onSubmit={handleSubmit}>
                <div className="required_field">
                    <p className="asterisk">*</p>
                    <TextInput inputType={"password"} value={password} onChange={(e) => setPassword(e.target.value)} required error={error ? true : false} />
                </div>
                <div className="required_field">
                    <p className="asterisk">*</p>
                    <TextInput inputType={"confirm_password"} value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} required error={error ? true : false} />
                </div>
                <button type="submit" className={`login_buttons ${styles.submit_reset_password} ${fontFamilyOne}`}>Reset</button>
            </form>
        </div>
    );
};

export default ResetPassword;
